import React from "react";
import "./banner.css";


/**
 * Banner
 * ----------------
 * - *** :)
 */

type BrandingKey = "gemba" | "actica" | "ntegra";
type BannerProps = { branding?: BrandingKey };

const logoByBrand: Record<BrandingKey, { src: string; alt: string }> = {
  gemba:  { src: "/assets/logos/gemba-advantage.svg",     alt: "Gemba Advantage" },
  actica: { src: "/assets/logos/actica-consulting.svg",   alt: "Actica Logo" },
  ntegra: { src: "/assets/logos/ntegra.svg",              alt: "Ntegra Logo" },
};

const Banner: React.FC<BannerProps> = ({ branding = "gemba" }) => {
  const { src, alt } = logoByBrand[branding] ?? logoByBrand.gemba;

  return (
    <div className="banner">
      <img
        src={src}
        alt={alt}
        className="banner__logo"
      />
    </div>
  );
};

export default Banner;

